import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'kp-confirm-member-exit-dialog',
  template: `<h1 mat-dialog-title>Looks like you want to exit the team</h1>
    <mat-dialog-content>
      <p>Are you sure you want to leave {{ data.teamGroupName }}?</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button class="secondary-action-button" mat-button aria-label="Cancel - stay in the team" (click)="onCancel()">
        Cancel
      </button>
      <button
        class="primary-action-button"
        mat-button
        [attr.aria-label]="'Confirm - leave ' + data.teamGroupName"
        (click)="onConfirm()">
        Confirm
      </button>
    </mat-dialog-actions>`,
  styleUrls: ['./confirm-group-member-exit-dialog.component.scss'],
})
export class ConfirmMemberExitDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmMemberExitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
